module.exports = __webpack_public_path__ + "img/Portugal.6e084eef.svg";